<template >
  <div class="Typeahead">
  <input
    class="form-control form-control-sm ml-2 back-office-search"
    placeholder="Back Office Inquiry"
    type="text"
    autocomplete='off'
    v-model='query'
    ref='input'
    @keydown.down='down'
    @keydown.up='up'
    @keydown.enter='hit'
    @keydown.esc='reset'
    @blur="reset"
    @input='update'>
    <ul class="list-group position-absolute" v-show="hasItems" style="z-index: 2;">
      <li class="list-group-item d-flex justify-content-between align-items-center"
        v-for="(item, $item) in items"
        :key="item.id"
        :class="activeClass($item)"
        @mousedown="hit"
        @mousemove="setActive($item)">
        <div v-html="highlight(item)"></div>
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from 'vue-typeahead'
import config from '@/config/global.config'

export default {
  name: 'BackOfficeSearch',
  extends: VueTypeahead,

  data () {
    return {
      src: `${config.appUrl}/back_office/search/backoffice/`,
      minChars: 1,
      selectFirst: true,
      queryParamName: false
    }
  },
  methods: {
    highlight (item) {
      let display = item.id + ' - ' + item.name
      return display.replace(new RegExp(this.query, 'gi'), match => {
        return '<strong>' + match + '</strong>'
      })
    },

    onHit (item) {
      window.location = `${config.appUrl}#/admin/backoffice/view/` + item.id
    }
  }
}
</script>

<style>
  .back-office-search {
    box-sizing: border-box;
    font-size: 13px;
    line-height: 1.5;
    border-radius: 0px;
    padding: 0 5px;
    font-family: Arial,Helvetica,sans-serif;
    height: 26px;
  }
</style>
